import { render, staticRenderFns } from "./gj-step.vue?vue&type=template&id=f3a39764&scoped=true&"
import script from "./gj-step.vue?vue&type=script&lang=js&"
export * from "./gj-step.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3a39764",
  null
  
)

export default component.exports